<template>
    <!-- Overlay -->
    <div v-if="drawerPassword && !isFdNext" class="custom-overlay" @click="closeDrawer"></div>

    <!-- Right-side drawer -->
    <v-navigation-drawer
      v-model="drawerPassword"
      location="right"
      temporary
      :scrim="!isFdNext"
      width="400"
      class="manage-users-drawer custom-drawer fd-drawer fd-profile-password-drawer"
    >
        <v-card flat>
            <!-- Header with Close Button -->
            <v-card-title class="d-flex justify-space-between align-center pa-0">
                <span class="text-h6 pa-0">Change Password</span>
                <img
                    :src="closeCircleIcon"
                    alt=""
                    width="20"
                    height="20"
                    class="fd-drawer-close fd-action-icon"
                    @click="closeDrawer"
                />
            </v-card-title>

            <v-card-text class="fd-profile-password-drawer__body">
                <v-window v-model="tab">
                    <v-window-item value="user">
                        <!-- Password Field -->
                        <label>Password</label>
                        <v-text-field v-model="password" :type="showPassword ? 'text' : 'password'" variant="solo"
                            class="custom-field" dense outlined hide-details placeholder="User password" :error-count="2"
                            autocomplete="new-password" :error-messages="passwordError" @input="validatePassword">
                            <template v-slot:append-inner>
                                <img
                                  :src="showPassword ? eyeOffIcon : eyeIcon"
                                  alt=""
                                  width="20"
                                  height="20"
                                  class="fd-action-icon"
                                  @click="showPassword = !showPassword"
                                />
                            </template>
                        </v-text-field>

                        <!-- Confirm Password Field -->
                        <label>Confirm Password</label>
                        <v-text-field v-model="confirmPassword" :type="showConfirmPassword ? 'text' : 'password'"
                            variant="solo" class="custom-field" dense outlined hide-details placeholder="Confirm password"
                            autocomplete="new-password" :error-messages="confirmPasswordError"
                            @input="validateConfirmPassword">
                            <template v-slot:append-inner>
                                <img
                                  :src="showConfirmPassword ? eyeOffIcon : eyeIcon"
                                  alt=""
                                  width="20"
                                  height="20"
                                  class="fd-action-icon"
                                  @click="showConfirmPassword = !showConfirmPassword"
                                />
                            </template>
                        </v-text-field>
                    </v-window-item>
                </v-window>
            </v-card-text>

            <!-- Action Buttons -->
            <div class="d-flex">
                <v-col cols="6" class="pa-0 mt-2 pr-1">
                    <v-btn flat class="reset-btn text-none" @click="closeDrawer">
                        <img :src="closeIcon" alt="" width="16" height="16" class="fd-action-icon" />
                        <span>Cancel</span>
                    </v-btn>
                </v-col>
                <v-col cols="6" class="pa-0 mt-2 pl-1">
                    <v-btn flat class="save-btn filter-wrap-btn text-none" :loading="createLoading"
                        :disabled="isSaveDisabled" @click="savePassword">
                        <img :src="saveIcon" alt="" width="16" height="16" class="fd-action-icon" />
                        <span>Save</span>
                    </v-btn>
                </v-col>
            </div>
        </v-card>
    </v-navigation-drawer>

    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :timeout="snackbar.timeout">
        {{ snackbar.message }}
    </v-snackbar>
</template>

<script>
import api from "../../../axiosInterceptor";

export default {
    props: {
        modelValue: Boolean,
        editUser: Object,
    },
    data() {
        return {
            tab: "user",
            save: require("../../../assets/Images/save btn.png"),
            closeCircleIcon: require("../../../assets/Svg/Icons/cross-circle.svg"),
            closeIcon: require("../../../assets/Svg/Icons/cross.svg"),
            saveIcon: require("../../../assets/Svg/Icons/save.svg"),
            eyeIcon: require("../../../assets/Svg/Icons/eye.svg"),
            eyeOffIcon: require("../../../assets/Svg/Icons/eye-slash.svg"),
            password: "",
            confirmPassword: "",
            showPassword: false,
            showConfirmPassword: false,
            passwordError: "",
            confirmPasswordError: "",
            createLoading: false,
            snackbar: {
                visible: false,
                message: "",
                color: "success",
                timeout: 3000,
            },
        };
    },
    computed: {
        drawerPassword: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit("update:modelValue", value);
            },
        },
        isFdNext() {
            return document.documentElement.classList.contains("fd-next");
        },
        isSaveDisabled() {
            return (
                !this.password ||
                !this.confirmPassword ||
                this.passwordError ||
                this.confirmPasswordError
            );
        },
    },
    watch: {
        modelValue: {
            immediate: true,
            handler(open) {
                document.documentElement.classList.toggle(
                    "fd-password-drawer-open",
                    Boolean(open)
                );
            },
        },
        password(newVal) {
            this.validatePassword();
        },
        confirmPassword(newVal) {
            this.validateConfirmPassword();
        },
    },
    beforeUnmount() {
        document.documentElement.classList.remove("fd-password-drawer-open");
    },
    methods: {
        showSnackbar(message, color = "success") {
            this.snackbar.message = message;
            this.snackbar.color = color;
            this.snackbar.visible = true;
        },
        validatePassword() {
            const password = this.password;
            if (!password) {
                this.passwordError = "Password is required.";
            } else if (password.length < 8) {
                this.passwordError = "Password must be at least 8 characters.";
            } else if (!/[A-Z]/.test(password)) {
                this.passwordError = "Must contain one uppercase letter.";
            } else if (!/[0-9]/.test(password)) {
                this.passwordError = "Must contain at least one number.";
            } else if (!/[!@#$%^&*]/.test(password)) {
                this.passwordError = "Must contain one special character.";
            } else {
                this.passwordError = "";
            }
            this.validateConfirmPassword(); // Ensure confirm password is revalidated
        },
        validateConfirmPassword() {
            if (!this.confirmPassword) {
                this.confirmPasswordError = "Confirm Password is required.";
            } else if (this.confirmPassword !== this.password) {
                this.confirmPasswordError = "Passwords do not match.";
            } else {
                this.confirmPasswordError = "";
            }
        },
        async savePassword() {
            this.validatePassword();
            this.validateConfirmPassword();
            if (this.passwordError || this.confirmPasswordError) {
                return;
            }

            this.createLoading = true;
            try {
                const userId = this.editUser.id;
                const response = await api.post(`/public/api/admin/password-update/${userId}`, {
                    password: this.password
                });

                if (response.data.statusCode === 200) {
                    this.showSnackbar("Password updated successfully!", "success");
                    this.$emit("user-updated");
                    this.closeDrawer();
                } else {
                    this.showSnackbar(response.data.message, "error");
                }
            } catch (error) {
                this.showSnackbar(error.response?.data?.message || "An error occurred", "error");
            } finally {
                this.createLoading = false;
            }
        },
        closeDrawer() {
            this.drawerPassword = false;
            this.resetForm();
        },
        resetForm() {
            this.password = "";
            this.confirmPassword = "";
            this.passwordError = "";
            this.confirmPasswordError = "";
        },
    },
};
</script>
